<script setup>
/* eslint-disable */
import { defineModel, ref, watch } from 'vue'

const status = defineModel('status')

const availableStatuses = [
    "subs",
    "transactions"
]

// Реф для позиции слайдера (0 - левая, 1 - правая)
const sliderPosition = ref(0)

// Отслеживаем изменение статуса для анимации слайдера
watch(status, (newStatus) => {
    const index = availableStatuses.indexOf(newStatus)
    if (index !== -1) {
        sliderPosition.value = index
    }
}, { immediate: true })

function switchStatus(switchStatus) {
    if (status.value !== switchStatus) {
        status.value = switchStatus
    }
}
</script>

<template>
    <div class="relative w-full bg-[#EDEEF2] rounded-[12px] h-10 lg:h-10 flex items-center p-1 shadow-inner">
        <div
            class="absolute h-8 bg-white rounded-[10px] shadow-md transition-all duration-300 ease-in-out"
            :style="{
            width: 'calc(50% - 4px)',
            left: sliderPosition === 0 ? '4px' : 'calc(50% + 0px)',
            transform: sliderPosition === 0 ? 'none' : 'translateX(0)'
        }"
        ></div>

        <div class="relative w-full flex items-center gap-1 z-10">
            <div
                class="w-1/2 rounded-[10px] h-8 cursor-pointer flex items-center justify-center transition-colors duration-200 px-2"
                :class="{
                    'hover:bg-[#DEDFE2]': status !== availableStatuses[0],
                }"
                @click="switchStatus(availableStatuses[0])"
            >
                <span class="font-bold text-[13px] lg:text-base text-center">Подписка на тариф</span>
            </div>
            <div
                class="w-1/2 rounded-[10px] h-8 cursor-pointer flex items-center justify-center transition-colors duration-200 px-2"
                :class="{
                    'hover:bg-[#DEDFE2]': status !== availableStatuses[1],
                }"
                @click="switchStatus(availableStatuses[1])"
            >
                <span class="font-bold text-[13px] lg:text-base text-center">Докупить транзакции</span>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>